import { memo } from 'react';


const TableCellValue = ({children}) => children;


export default memo(TableCellValue)